/**
 * Time left on a reservation's hold, coloured by urgency. Extracted from
 * `WorkshopReservations` unchanged (BON-472) so that file declares one
 * component, which `react/no-multi-comp` now enforces on any file it touches.
 */
import { expiresInLabel } from '../../../bookings/reservationFormat';

/** Expiry inside this window renders as urgent. */
const URGENT_MS = 60 * 60 * 1000;

export function WorkshopReservationExpiryLabel({ expiresAt }: { expiresAt: string }) {
  const urgent = new Date(expiresAt).getTime() - Date.now() <= URGENT_MS;
  const label = expiresInLabel(expiresAt);
  // `expiresInLabel` returns whole words for its edge cases, not durations, so
  // the prefix stands down or a stale page reads "expires expired".
  const isDuration = label !== 'expired' && label !== '—';
  return (
    <span
      style={{
        fontSize: 11.5,
        whiteSpace: 'nowrap',
        color: urgent ? 'var(--nb-risk)' : 'var(--nb-subtle)',
      }}
    >
      {isDuration ? `expires ${label}` : label}
    </span>
  );
}
